import { DirectionEnum } from "../components/enums/DirectionEnum";
import { BaseCharacter } from "./BaseCharacter";
import { CharacterTypeEnum } from "./CharacterTypeEnum";

export class MainCharacter extends BaseCharacter {
    constructor(scene: Phaser.Scene, x: number, y: number, frameRate: number, direction: DirectionEnum) {
        super(scene, x, y, CharacterTypeEnum.Main, frameRate, direction);
    }
}